<!--
 * @Author: zyy
 * @Date: 2022-09-21 13:19:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-13 10:59:25
 * @Description: default
-->
<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
                <a-col :span="24" :xl="6">
                    <a-row :gutter="[8, 8]">
                        <a-col>
                            <p>订单编号:</p>
                        </a-col>
                        <a-col>
                            <a-input placeholder="请输入订单编号" v-model="searchQuery.order_sn"></a-input>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="24" :xl="6">
                    <a-row :gutter="[8, 8]">
                        <a-col>
                            <p>下单时间:</p>
                        </a-col>
                        <a-col>
                            <a-range-picker format="YYYY-MM-DD HH:mm:ss" v-model="searchQuery.createtime"
                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                valueFormat="YYYY-MM-DD HH:mm:ss" style="width:100%" />
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="24" :xl="6">
                    <a-space>
                        <a-button type="primary" @click="getList">查询</a-button>
                        <a-button @click="searchReset">重置</a-button>
                        <a-button type="primary" @click="searchReset">
                            刷新</a-button>
                    </a-space>
                </a-col>
            </a-row>

            <a-tabs v-model="status" @change="getList">
                <a-tab-pane key="-1" tab="全部"></a-tab-pane>
                <a-tab-pane key="cancel" tab="已取消"></a-tab-pane>
                <a-tab-pane key="nopay" tab="待付款"></a-tab-pane>
                <a-tab-pane key="nosend" tab="待发货"></a-tab-pane>
                <a-tab-pane key="nocomment" tab="待评价"></a-tab-pane>
                <a-tab-pane key="finish" tab="已完成"></a-tab-pane>
                <a-tab-pane key="refund" tab="退款"></a-tab-pane>
                <!-- <a-button slot="tabBarExtraContent" @click="orderExport">订单导出</a-button> -->
            </a-tabs>
            <a-spin :spinning="loading">
                <div style="width:100%">
                    <div class="table-title">
                        <a-checkbox style="flex:1" @change="allCheck"></a-checkbox>
                        <span style="flex:5">商品信息</span>
                        <!-- <span class="table-title-item">退款状态</span>
                        <span class="table-title-item">售后状态</span> -->
                        <!-- <span class="table-title-item">所属门店</span> -->
                        <!-- <span class="table-title-item">配送方式</span> -->

                        <span class="table-title-item">发货状态</span>
                        <span class="table-title-item">订单状态</span>
                        <span class="table-title-item">下单用户</span>
                        <span class="table-title-item">收货信息</span>
                        <span class="table-title-item">操作</span>
                    </div>
                    <div class="table-data">
                        <div class="table-data-item" v-for="item in tableData" :key="item.id">
                            <div class="table-data-item-title">
                                <a-checkbox style="width:100px" v-model="item.checked"></a-checkbox>
                                <span class="mr-20">ID:{{ item.id }}</span>
                                <span class="mr-20">订单号:{{ item.order_sn }}</span>
                                <span class="mr-20">下单时间:{{ item.createtime }}</span>
                                <!-- <span class="mr-20">App-商城订单</span> -->
                            </div>
                            <div class="table-data-goods">
                                <div class="goods-list">
                                    <div class="row-item" v-for="goods in item.item" :key="goods.id">
                                        <div class="goods-list-item">
                                            <div>
                                                <img :src="goods.goods_image" width="50" height="50">
                                            </div>
                                            <div class="goods-info">
                                                <div>{{ goods.goods_title }}</div>
                                                <div class="info-bottom">
                                                    <span class="mr-20">单价：{{ goods.goods_price }}</span>
                                                    <span>数量：{{ goods.goods_num }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <span class="table-data-goods-item">{{ goods.refund_status_text }}</span> -->
                                        <!-- <a-button v-if="goods.btns && goods.btns.includes('aftersale_info')" type="link" class="table-data-goods-item"
                                            @click="openAfterModal(goods)">售后详情
                                        </a-button> -->
                                        <!-- <span class="table-data-goods-item">{{ goods.aftersale_status_text }}</span> -->
                                        <!-- <span class="table-data-goods-item">{{'暂无门店信息'}}</span> -->
                                        <!-- <span class="table-data-goods-item">{{goods.dispatch_type_text}}</span> -->
                                    </div>
                                </div>
                                <div class="merge-box">
                                    <a-button
                                        v-if="item.btns && item.btns.includes('send') && item.status_code != 'groupon_ing'"
                                        type="link" @click="openSendModal(item)">去发货
                                    </a-button>

                                    <span v-else>{{ item.status_name }}</span>

                                </div>
                                <div class="merge-box">{{ item.status_name }}</div>
                                <div class="merge-box">{{ item.community_user ? item.community_user.nickname : "未知用户" }}
                                </div>
                                <div class="merge-box">{{ `${item.city_name}${item.area_name}${item.address}` }}</div>
                                <div class="merge-box">
                                    <a-button type="link" @click="openModal(item.id)">查看详情</a-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div style="text-align: center;margin-top: 10px;">
                    <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total" show-size-changer
                        :page-size="limit" @showSizeChange="onShowSizeChange" @change="getList">
                        <template slot="buildOptionText" slot-scope="props">
                            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                            <span v-if="props.value === '50'">全部</span>
                        </template>
                    </a-pagination>
                </div>
            </a-spin>
        </a-card>

        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
            destroy-on-close centered :width="1000">
            <OrderInfo :info="modal.info"></OrderInfo>
        </a-modal>

        <a-modal :title="sendModal.title" :confirm-loading="sendModal.loading" v-model="sendModal.show"
            @ok="confirmSendModal" destroy-on-close centered :width="1000">
            <SendModal :goods="sendModal.goods" :addressInfo="sendModal.addressInfo" ref="sendRef"></SendModal>
        </a-modal>
        <AfterSale @submit="getList" ref="afterSaleRef" />
    </div>
</template>
  
<script>
import GoodsOrderService from "@/io/goods/order.js";
import OrderInfo from './modules/OderInfo.vue'
import SendModal from './modules/sendModal.vue'
import AfterSale from './modules/AfterSale.vue'
import { TJListMixin } from '@/mixins/list.js'
import moment from 'moment';
export default {
    mixins: [TJListMixin],
    components: {
        OrderInfo,
        SendModal,
        AfterSale
    },
    data() {
        return {
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            page: 1,
            limit: 10,
            total: 150,
            status: '-1',
            tableData: [],
            loading: false,
            searchQuery: {
                order_sn: undefined,
                createtime: undefined
            },
            modal: {
                title: '订单详情',
                loading: false,
                show: false,
                info: null
            },
            sendModal: {
                title: '订单发货',
                loading: false,
                show: false,
                goods: null,
            }
        };
    },
    methods: {
        moment,
        openAfterModal(data) {

            this.$refs.afterSaleRef.modal.data[0] = data
            this.$refs.afterSaleRef.modal.show = true
            console.log(data)
            GoodsOrderService.afterSaleInfo(data.dispatch_id).then(res => {
                this.$refs.afterSaleRef.info = res
                console.log(res, 44)
            })
        },
        getList() {
            this.loading = true
            const { createtime } = this.searchQuery
            GoodsOrderService.list({
                status: this.status === '-1' ? null : this.status,
                limit: this.limit,
                page: this.page,
                filter: {
                    order_sn: this.searchQuery.order_sn,
                    createtime: createtime ? `${createtime[0]} - ${createtime[1]}` : null
                },
                op: {
                    createtime: "range",
                    order_sn: "like"
                }
            }).then(res => {
                this.tableData = res.data?.rows
                // 添加checked选项
                this.tableData = this.tableData.map(val => {
                    return {
                        ...val,
                        checked: false
                    }
                })
                this.total = res.data?.total
            }).finally(() => {
                this.loading = false
            })
        },
        // 全选
        allCheck(e) {
            this.tableData.forEach(val => val.checked = e.target.checked)
        },
        // 导出
        orderExport() {
            console.log(this.tableData)
        },
        // 详情
        openModal(id) {
            this.modal.loading = true
            GoodsOrderService.detail({ id }).then(res => {
                this.modal.info = res.data
                this.modal.show = true
            }).finally(() => this.modal.loading = false)

        },
        confirmModal() {
            this.modal.show = false
        },

        // 详情
        openSendModal(item) {
            this.sendModal.goods = item
            this.sendModal.show = true
            this.sendModal.addressInfo = {
                id: item.id,
                consignee: item.consignee,
                phone: item.phone,
                address: item.city_name + item.area_name + item.address
            }



        },
        confirmSendModal() {
            // console.log(this.$refs.sendRef.submit())
            this.$refs.sendRef.submit().then(res => {
                if (res.code === 1) {
                    this.sendModal.show = false
                    this.getList()
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                console.log(err)
            })

            // if(this.$refs.sendRef.submit()) this.sendModal.show=false
            // 
        },

        onShowSizeChange(current, pageSize) {
            this.limit = pageSize;
            this.getList()
        },
    },
};
</script>
<style scoped lang="less">
.table-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background-color: #f5f5f5;

    .table-title-item {
        flex: 1;
        min-width: 117px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.mr-20 {
    margin-right: 20px;
}

.table-data {
    width: 100%;

    .table-data-item {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        padding: 10px 20px;
        background-color: #f5f5f5;
        margin-bottom: 20px;

        .table-data-item-title {
            color: #8e8d8d;
            padding: 10px 0;
        }
    }

    .table-data-goods {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        width: 100%;
        background-color: #fff;

        .goods-list {
            flex: 6;

            .goods-list-item {
                padding: 10px 20px;
                border-bottom: 1px solid #e3e3e3;
                display: flex;
                height: 76px;
                flex: 6;

                .goods-info {
                    margin-left: 20px;

                    .info-bottom {
                        margin-top: 10px;
                        color: #8e8d8d;
                    }
                }
            }

        }

        .item-box {
            flex: 1;
            justify-content: space-between;
            display: flex;
            flex-direction: column;
            align-items: center;

        }

        .table-data-goods-item {
            flex: 1;
            padding: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            border-bottom: 1px solid #e3e3e3;
            height: 76px;
            min-width: 117px;
        }
    }

    .table-data-goods:hover {
        background-color: #f5faff;
    }
}

.merge-box {
    flex: 1;
    min-width: 117px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e3e3e3;
}

.row-item {
    display: flex;
}
</style>
  